// extracted by mini-css-extract-plugin
module.exports = {"wrapperStyles":"LoyaltyTabSection_wrapperStyles__MEcWM"};